import { createFileRoute, redirect } from '@tanstack/react-router';
import { ShowcasePage } from '@/shared/ui/showcase/ShowcasePage';

/**
 * /dev/ui — UI-kit showcase (every shared/ui component, all variants). Dev builds only.
 * `?open=modal-form | modal-create | confirm | sheet | popover | menu | tooltip` opens an overlay for screenshots.
 */
export const Route = createFileRoute('/dev/ui')({
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw redirect({ to: '/' });
  },
  validateSearch: (search: Record<string, unknown>): { open?: string } => ({
    open: typeof search.open === 'string' ? search.open : undefined,
  }),
  component: DevUiRoute,
});

function DevUiRoute() {
  const { open } = Route.useSearch();
  return <ShowcasePage open={open} />;
}
